export const LOCAL_API = "https://us-central1-feirafacil-2022.cloudfunctions.net/app/"
// export const LOCAL_API = "http://localhost:5001/feirafacil-2022/us-central1/app/"